var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmotion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 99,
    viewBox: "0 0 104 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_231_14402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.3529 66.1559V76.7441M48.3529 29.0971V18.5088M48.3529 18.5088C52.7386 18.5088 56.2941 14.9534 56.2941 10.5676C56.2941 6.18184 52.7386 2.62646 48.3529 2.62646C43.9673 2.62646 40.4118 6.18184 40.4118 10.5676C40.4118 14.9534 43.9673 18.5088 48.3529 18.5088ZM90.7059 92.6265V87.3323C90.7059 81.4845 85.9655 76.7441 80.1176 76.7441H16.5882C10.7405 76.7441 6 81.4845 6 87.3323V92.6265H90.7059ZM43.0588 47.6265C43.0588 50.5504 40.6886 52.9206 37.7647 52.9206C34.8409 52.9206 32.4706 50.5504 32.4706 47.6265C32.4706 44.7025 34.8409 42.3323 37.7647 42.3323C40.6886 42.3323 43.0588 44.7025 43.0588 47.6265ZM64.2353 47.6265C64.2353 50.5504 61.8651 52.9206 58.9412 52.9206C56.0172 52.9206 53.6471 50.5504 53.6471 47.6265C53.6471 44.7025 56.0172 42.3323 58.9412 42.3323C61.8651 42.3323 64.2353 44.7025 64.2353 47.6265ZM27.1765 66.1559H69.5294C75.3773 66.1559 80.1176 61.4155 80.1176 55.5676V39.6853C80.1176 33.8376 75.3773 29.0971 69.5294 29.0971H27.1765C21.3287 29.0971 16.5882 33.8376 16.5882 39.6853V55.5676C16.5882 61.4155 21.3287 66.1559 27.1765 66.1559Z",
    stroke: "url(#paint0_linear_231_14402)",
    strokeWidth: 4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_231_14402",
    x: 0,
    y: 0.626465,
    width: 96.7061,
    height: 102,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_231_14402"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_231_14402",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_231_14402",
    x1: 48,
    y1: 48.3735,
    x2: 48.3529,
    y2: 92.6265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01B0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E2688"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmotion);
export default __webpack_public_path__ + "static/media/Emotion.ccb7c978a4d21cdf77946793e5fc1f55.svg";
export { ForwardRef as ReactComponent };